// extracted by mini-css-extract-plugin
var _1 = "kz5CC";
var _2 = "vh2n3";
export { _1 as "base", _2 as "title" }
